import React from 'react';
import type { IconProps } from '../types';

const isMobile = window.innerWidth < 640;
const searchParams = new URLSearchParams(window.location.search);
const customerKey = searchParams.get('customerKey');
const viewBox = isMobile && customerKey === '528' ? '0 3 16 15' : '3 3 16 15';

export const SidePanelCloseLeft = (props: IconProps) => (
  <svg
    width="20px"
    height="20px"
    viewBox={viewBox}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>icon-panel-close-left</title>
    <g
      id="Artboards-Updated"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Segmentation---assets"
        transform="translate(-370, -60)"
      >
        <g
          id="icon-panel-close-left"
          transform="translate(380, 70) scale(-1, 1) translate(-380, -70)translate(370, 60)"
        >
          <rect
            id="Rectangle"
            x="0"
            y="0"
            width="20"
            height="20"
          ></rect>
          <line
            x1="12.8336364"
            y1="10.4061473"
            x2="3"
            y2="10.4061473"
            id="Path"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            transform="translate(7.9168, 10.4061) scale(-1, 1) translate(-7.9168, -10.4061)"
          ></line>
          <polyline
            id="Path"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            transform="translate(10.7991, 10.4061) scale(-1, 1) translate(-10.7991, -10.4061)"
            points="12.8336364 6.33705636 8.76454545 10.4061473 12.8336364 14.4752382"
          ></polyline>
          <line
            x1="16.2418182"
            y1="14.4752382"
            x2="16.2418182"
            y2="6.33705636"
            id="Path"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            transform="translate(16.2418, 10.4061) scale(-1, 1) translate(-16.2418, -10.4061)"
          ></line>
        </g>
      </g>
    </g>
  </svg>
);

export default SidePanelCloseLeft;
